<template>
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 98.9 105.95">
        <path
            fill="#ffffff"
            d="M707.67,338.41c7.84,0,14.44,5,16.87,12.8,2.25,7.19-.83,15.55-7.35,19.94a16.92,16.92,0,0,1-20.43-1.07c-2-1.67-3.48-1.79-5.7-.45-6,3.61-12.11,7-18.23,10.36-1.44.8-2,1.57-1.64,3.33a17.75,17.75,0,0,1,0,5.68c-.17,1.32-.1,2.14,1.19,2.85,6.83,3.8,13.66,7.62,20.41,11.58,1.73,1,2.41-.18,3.36-1a17.48,17.48,0,0,1,25.9,3.14,18.53,18.53,0,0,1,.57,20.06c-3.61,5.69-11.4,9.25-17.65,8.07-7.34-1.39-13.31-7-14.6-14a24.57,24.57,0,0,1,0-6.69c.14-1.46-.12-2.31-1.43-3-6.69-3.72-13.38-7.44-20-11.33-1.78-1.05-2.58,0-3.62.91-10.2,8.62-25.1,3.9-28.54-9a17.91,17.91,0,0,1,8.1-19.82,17,17,0,0,1,20.77,2.17c1.19,1.11,2,1.26,3.41.44q9.72-5.64,19.55-11.07c1.5-.83,1.82-1.65,1.57-3.35A17.61,17.61,0,0,1,707.67,338.41ZM707.59,426a10.08,10.08,0,1,0-10-10A10,10,0,0,0,707.59,426Zm-53.74-50.18a10.1,10.1,0,0,0,.14,20.19,10.1,10.1,0,0,0-.14-20.19Zm63.68-19.75a9.78,9.78,0,1,0-9.8,10.2A10,10,0,0,0,717.53,356.11Z"
            transform="translate(-633.02 -330.55)"
        ></path>
    </svg>
</template>

<script>
export default {
    name: "WebhookIcon",
};
</script>

<style scoped></style>
